import { createReducer } from 'utils/helpers';
import { CustomerPricingLookupActionTypes, IActions } from './CustomerPricingLookup.actions';

export interface IState {
    CalculatedData: any;
    InitialCalculatorData: any;
}

export const initialState: IState = {
    CalculatedData: undefined,
    InitialCalculatorData: undefined
};

type IAction = (state: IState, payload: any) => IState;

type IActionMap = Record<CustomerPricingLookupActionTypes, IAction>;

const actionMap: IActionMap = {
    [CustomerPricingLookupActionTypes.setCalculatedData]: (state: IState, payload: IState['CalculatedData']): IState => ({ ...state, CalculatedData: payload }),
    [CustomerPricingLookupActionTypes.setInitialCalculatordData]: (state: IState, payload: IState['InitialCalculatorData']): IState => ({ ...state, InitialCalculatorData: payload }),
};

export default createReducer<IActionMap, IState, IActions>(actionMap);
